import created from './attrs/created'
import data from './attrs/data'
import methods from './attrs/methods'
import watch from './attrs/watch'

export default {
    name: 'Users',
    created,
    data,
    methods,
    watch
}
